import {
  Button,
  Currencies,
  SFXS,
  mathOperations,
} from "@orbital/games-frontend-library"
import React, { useState, Fragment } from "react"
import { aboveTypes } from "../../../Types"
import { StakeButton } from "../FooterStyled"

export default function UpFloor({
  gameInfo,
  handleNotification,
  audio,
  handleAbove,
  audioUrl,
  handleStake,
  stake,
  rowDisabled,
}: any) {
  const { currency, minBet, maxBet, precision } = gameInfo

  const [anim, setAnim] = useState<boolean>(false)

  const clickHandler = (p: aboveTypes) => {
    setAnim(true)
    audioUrl.goForward()
    setTimeout(() => {
      handleAbove(p)
      setAnim(false)
    }, 167)
  }
  return (
    <Fragment>
      <Button
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "1/2",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency,
            ),
          )
        }
        audio={audio}
        SFX={SFXS.divideSFX}
        customClass={rowDisabled && "disable"}
        // disableColor={colors.secondaryBackground}
      >
        1/2
      </Button>
      <StakeButton
        onClick={() => !rowDisabled && clickHandler("SetStake")}
        anim={anim}
        className={rowDisabled ? "disabled" : "enabled"}
      >
        {(+stake).toFixed(precision)}
        {Currencies[currency]}
        <div className="white" />
      </StakeButton>
      <Button
        func={(e: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "2x",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency,
            ),
          )
        }
        audio={audio}
        SFX={SFXS.multiplySFX}
        customClass={rowDisabled && "disable"}
        // disableColor={colors.secondaryBackground}
      >
        2X
      </Button>
    </Fragment>
  )
}
